// extracted by mini-css-extract-plugin
module.exports = {"companyDetailWrapper":"style_companyDetailWrapper__bRoTT","contactFormWrapper":"style_contactFormWrapper___bEC9"};
module.exports.__checksum = "a29957ead023"